export default __webpack_public_path__ + "static/media/table_bubble.1803285e.png";